import React, { useEffect, useState } from 'react';
import { Modal as PlaceholderModal } from '@/components/custom/modal/modal';
import Confetti from '@/components/custom/confetti';
import CompletedConquest from './CompletedConquest';

export default function PtsModal(props) {
  const { setAchievementData, achievementData } = props;
  const [showPtsModal, setShowPtsModal] = useState(false);

  const onClose = () => {
    setShowPtsModal(false);
    setAchievementData(null);
  };

  useEffect(() => {
    if (achievementData) {
      setShowPtsModal(true);
    }
  }, [achievementData]);

  return (
    <PlaceholderModal
      show={showPtsModal}
      onClose={onClose}
    >
      <CompletedConquest
        achievementData={achievementData}
        onClose={onClose}
      />

      <Confetti />
    </PlaceholderModal>
  );
}
